import { imageServerConfig } from '../config/imageServer';

/**
 * Generates the appropriate image URL based on image type and variant
 * @param imageId - The ID of the image
 * @param imageType - The type of image (location-image, portrait, title-image, banner, icon)
 * @param variant - The variant size (thumbnail, card, large, small)
 * @returns The image URL
 */
export const generateImageUrl = (imageId: string, imageType: string, variant: string): string => {
  // Use imageServerConfig.baseUrl which handles localhost replacement for network access
  const baseUrl = imageServerConfig.baseUrl;
  
  // Escape the imageId to prevent XSS in URLs
  const escapedImageId = encodeURIComponent(imageId);
  
  switch (imageType) {
    case 'location-image':
      return `${baseUrl}/location-images/${escapedImageId}/${variant}`;
    case 'portrait':
      return `${baseUrl}/portraits/${escapedImageId}/${variant}`;
    case 'title-image':
      return `${baseUrl}/title-images/${escapedImageId}/${variant}`;
    case 'banner':
      return `${baseUrl}/banners/${escapedImageId}/${variant}`;
    case 'icon':
      return `${baseUrl}/icons/${escapedImageId}/${variant}`;
    default:
      // Fallback to generic image
      return `${baseUrl}/portraits/generic/${variant}`;
  }
};
